import React from 'react';
import type { Workspace } from '../../types/content';
export function WorkspaceTasks({
  workspace
}: {
  workspace: Workspace;
}) {
  return <section className="py-20 md:py-28" data-id="element-546" data-mp="1qcyegrkyw9l1">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-8 lg:grid-cols-[1fr_2fr]" data-id="element-547" data-mp="1cml4yksfgmtl">
        <h2 className="text-balance text-3xl font-semibold tracking-display md:text-4xl" data-id="element-548" data-mp="1gnwyv2ic3u7l">The work it supports.</h2>
        <dl className="grid gap-x-12 sm:grid-cols-2" data-id="element-549" data-mp="12nm8e0kxshmy">
          {workspace.tasks.map(t => <div key={t.title} className="border-t border-ink/[0.08] py-6" data-id="element-550" data-mp="17nrrgsd54vtf">
              <dt className="text-lg font-semibold tracking-tight" data-id="element-551" data-mp="17kvw9bsogl8o">{t.title}</dt>
              <dd className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-552" data-mp="tpjzkyuyokp4">{t.body}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}